import * as React from 'react';
import Checker from './Checker';
import Dropdown from './Dropdown';
import TextField from './TextField';
import IconColumn from './IconColumn';
import TextIcon from './TextIcon';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  wrapper: {
    textAlign: 'left',
    fontWeight: 'bold'
  }
};

var getCellType = function getCellType(_ref) {
  var header = _ref.header,
      types = _ref.types;
  return types.find(function (obj) {
    return obj.header === header;
  });
};

var buildTestClass = function buildTestClass(_ref2) {
  var appId = _ref2.appId,
      header = _ref2.header;

  if (header) {
    return "AppId-".concat(appId, "-Col-").concat(header.split(' ').join('_'));
  }

  return "AppId-".concat(appId);
};

var Cell = function Cell(props) {
  var renderTextField = function renderTextField(custom, props) {
    return React.createElement(TextField, {
      testClass: buildTestClass({
        appId: props.appId,
        header: props.header
      }),
      link: props.link,
      custom: custom,
      rowData: props.rowData,
      colData: props.colData,
      context: props.context
    }, props.children);
  };

  var renderContent = function renderContent() {
    if (props.custom) {
      var custom = getCellType({
        header: props.header,
        types: props.custom
      });

      if (custom) {
        switch (custom.type) {
          case 'checkbox':
            return React.createElement(Checker, {
              testClass: buildTestClass({
                appId: props.appId,
                header: props.header
              }),
              checked: custom.value ? custom.value : props.colData.get("value"),
              onClick: custom.onClick,
              value: custom.header,
              appId: props.appId,
              disabled: custom.disabled && custom.disabled(props.appId),
              colData: props.colData,
              custom: custom,
              style: custom.style ? custom.style(props.rowData, props.colData) : {},
              context: props.context
            });

          case 'dropdown':
            if (!custom.disabled || !custom.disabled(props.appId)) {
              var onSelect = function onSelect(value) {
                return custom.onSelect(props.appId, value);
              };

              return React.createElement(Dropdown, {
                testClass: buildTestClass({
                  appId: props.appId,
                  header: props.header
                }),
                value: custom.value(props.appId),
                onSelect: onSelect,
                options: custom.options,
                colData: props.colData,
                custom: custom,
                context: props.context
              }, props.children);
            }

            return null;

          case 'icon':
            return React.createElement(IconColumn, {
              testClass: buildTestClass({
                appId: props.appId,
                header: props.header
              }),
              onClick: custom.onClick,
              renderIcons: custom.renderIcons,
              index: props.index,
              rowData: props.rowData,
              colData: props.colData,
              custom: custom,
              context: props.context
            }, props.children);

          case 'texticon':
            return React.createElement(TextIcon, {
              testClass: buildTestClass({
                appId: props.appId,
                header: props.header
              }),
              prefix: custom.prefix,
              postfix: custom.postfix,
              icon: custom.icon,
              index: props.index,
              rowData: props.rowData,
              onIconClick: custom.onIconClick,
              colData: props.colData,
              custom: custom,
              context: props.context
            }, props.children);

          case 'textclick':
            return React.createElement(TextField, {
              testClass: buildTestClass({
                appId: props.appId,
                header: props.header
              }),
              onClick: custom.onClick,
              appState: custom.appState,
              tab: custom.tab,
              custom: custom,
              rowData: props.rowData,
              colData: props.colData,
              context: props.context
            }, props.children);

          default:
            return renderTextField(custom, props);
        }
      }
    }

    return renderTextField({}, props);
  };

  return React.createElement("div", {
    className: props.classes.wrapper,
    "data-testid": "cell"
  }, renderContent());
};

export default withStyles(styles)(Cell);